import { Button, Flex, Modal, Text } from "@mantine/core";
import { usePostApi } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setShowGDPRModal } from "src/redux/slices/preferencesSlice";

const GPDRModal = () => {
  const dispatch = useDispatch();
  const { showGDPRModal } = useSelector(state => state.preferencesSlice);
  const { post } = usePostApi();

  const handleClose = () => {
    dispatch(setShowGDPRModal(false));
  };

  const handleYes = async () => {
    await post({
      request: "sign-off-gdpr",
      body: {},
      onSuccess: () => handleClose(),
    });
    // close();
  };
  return (
    <Modal
      size={"xl"}
      yOffset={"15dvh"}
      opened={showGDPRModal}
      onClose={handleClose}
      title="GDPR Notice">
      <Text>
        I consent to the sharing of my personal data (Name /Date of
        Birth/Address/Salary/Qualifications & certs/CV & Experience) with the
        Yacht Owner, Their representatives, The Company, The Employment Company
        and the Yacht Manager.
      </Text>
      <Flex w={"100%"} justify={"center"} gap={10} mt={20}>
        <Button w={80} onClick={handleYes}>
          Yes
        </Button>
        <Button w={80} onClick={handleClose}>
          No
        </Button>
      </Flex>
    </Modal>
  );
};

export default GPDRModal;
